/* eslint-disable-next-line primer-react/no-deprecated-flash -- Existing Flash usage should be migrated to Banner. */
import {Flash} from '@primer/react'
import type {RefObject, ReactNode} from 'react'
import {clsx} from 'clsx'
import styles from './RulesetFormErrorFlash.module.css'

/**
 * Props for a generic error flash component in the ruleset form
 * @param {ReactNode} props.children
 * @param {RefObject<HTMLDivElement>} [props.errorRef] Use this ref to focus on the error
 * @param {string} props.errorId
 *   errorId is a unique identifier used to reference the rule input/target,
 *   it should be the same value as the aria-describedby attribute in the input/target element
 * @returns {JSX.Element}
 */
export function RulesetFormErrorFlash({
  errorId,
  children,
  errorRef,
  className,
}: {
  children: ReactNode
  errorRef?: RefObject<HTMLDivElement | null>
  errorId: string
  className?: string
}): React.ReactElement {
  return (
    <div className={clsx(className, styles.RulesetFormErrorFlashContainer)}>
      <Flash ref={errorRef} variant="danger" className={styles.RulesetFormErrorFlash} id={errorId} tabIndex={0}>
        {children}
      </Flash>
    </div>
  )
}
